import React, { useMemo } from 'react';
import { Flex } from 'antd';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { TargetRespondent } from 'jf/api';
import { useDevExTheme } from 'jf/common/themes/DevExTheme';
import { DevExAlert } from 'jf/components/DevExAlert';
import { DevExButton } from 'jf/components/DevExButton';
import { DevExText } from 'jf/components/DevExText';

type SlackUserWarningProps = {
  users: TargetRespondent[];
  enabled: boolean;
  onClick: () => void;
};

export const SlackUserWarning: React.FC<SlackUserWarningProps> = ({ users, onClick, enabled }) => {
  const theme = useDevExTheme();
  const usersWithoutSlack = useMemo(() => {
    return users.filter((u) => !u.slack);
  }, [users]);

  if (usersWithoutSlack.length) {
    return (
      <DevExAlert
        message={
          <Flex gap={theme.variable.spacing.sm} align="center">
            <DevExText lined>
              <strong>
                {usersWithoutSlack.length} {usersWithoutSlack.length === 1 ? 'person ' : 'people '}
              </strong>
              from your roster {usersWithoutSlack.length === 1 ? "doesn't" : "don't"} have Slack
              linked to their profile and won't receive this survey unless you link one now.
            </DevExText>
            <DevExButton type="link" onClick={() => onClick()}>
              {enabled ? 'Hide unlinked users' : 'Link users'}
            </DevExButton>
          </Flex>
        }
        icon={
          <FontAwesomeIcon color={theme.color.status.warning.text} icon={faExclamationCircle} />
        }
        showIcon
        type="warning"
      />
    );
  }
  return null;
};
